//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
import httpHelper from '../../src/common/helpers/HttpHelper';
import environments from '../../src/common/environments/environment';
const http = new httpHelper();

export const SystemMessageActions = {
    GetCountriesJson: getCountriesJson,
    GetTimezoneJson: getTimezoneJson,
    PostPublishMessage: postPublishMessage,
    GetSystemMessageJson: getSystemMessageJson,
    GetSystemMessages: getSystemMessages,
    UpdateSystemMessage: updateSystemMessage,
    DeleteSystemMessage: deleteSystemMessage,
}

function getCountriesJson() {
    return http.getCountriesData(environments.COUNTRIES);
}

function getTimezoneJson(language) {
    language = language.toLowerCase();
    return http.getTimezoneData(environments.TIMEZONE.replace('{lang}', language));
}

function postPublishMessage(data) {
    return http.postMessage(environments.PUBLISH_MESSAGE, data);
}

function getSystemMessageJson(UserId) {
    return http.jsonGet(environments.CONTAINER_NAME + environments.SYSTEM_MESSAGE_JSON);
}

function getSystemMessages(countryId) {
    return http.getSystemMessages(environments.SYSTEM_MESSAGE.replace('{id}', countryId));
}

function updateSystemMessage(messageId, data) {
    return http.updateSystemMessage(environments.UPDATE_SYSTEM_MESSAGE.replace('{id}', messageId), data);
}

function deleteSystemMessage(messageId) {
    return http.deleteSystemMessage(environments.UPDATE_SYSTEM_MESSAGE.replace('{id}', messageId));
}
